import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Dialog from './dialog/Dialog'
import styles from './ConfirmModalV2.module.scss'

//TODO (JEFF) document the params and use cases for this component

const ConfirmModalV2 = ({
  className,
  headerText,
  icon,
  subtext,
  buttonOneText,
  buttonTwoText,
  onButtonOneClick,
  onButtonTwoClick,
  singleButtonOnly,
  isKiosk,
}) => {
  const classNames = cn(styles.confirmModalV2, className)
  const singleButtonStyle = singleButtonOnly ? { width: '100%' } : {}

  return (
    <Dialog className={classNames} isKiosk={isKiosk}>

      <div className={isKiosk ? styles.kioskContainer : styles.container}>
        {isKiosk ? (
          <div className={styles.textBox}>
            {icon && <div className={styles.icon}>{icon}</div>}
            <h1 className={styles.headerText}>{headerText}</h1>
            {subtext && (<span className={styles.subtext}>{subtext}</span>)}
          </div>
        ) : (
          <div className={styles.textBox}>
            {icon && <div className={styles.icon}>{icon}</div>}
            {headerText && (
              <div className={styles.headerText}>{headerText}</div>
            )}
            {headerText && subtext ? (
              <div className={subtext.length < 100 ? styles.subtext : styles.smallSubtext}>{subtext}</div>
            ) : (
              <div className={subtext.length < 100 ? styles.subtext : styles.smallSubtext}>{subtext}</div>
            )}
          </div>
        )}
        <div className={styles.buttonContainer}>
          {!singleButtonOnly && (
            <div
              className={isKiosk ? styles.button2 : styles.button}
              onClick={onButtonOneClick}
            >
              {buttonOneText}
            </div>
          )}
          <div
            className={isKiosk ? styles.button2 : styles.button}
            onClick={onButtonTwoClick}
            style={singleButtonStyle}
          >
            {buttonTwoText}
          </div>
        </div>
      </div>
    </Dialog>
  )
}

ConfirmModalV2.defaultProps = {
  buttonOneText: 'CANCEL',
  buttonTwoText: 'CONFIRM',
  headerText: "Confirm before proceeding",
  isKiosk: false,
  onButtonOneClick: () => {},
  onButtonTwoClick: () => {},
  singleButtonOnly: false,
  subtext: '',
}

ConfirmModalV2.propTypes = {
  buttonOneText: PropTypes.string,
  buttonTwoText: PropTypes.string,
  isKiosk: PropTypes.bool,
  onButtonOneClick: PropTypes.func,
  onButtonTwoClick: PropTypes.func,
  singleButtonOnly: PropTypes.bool,
  subtext: PropTypes.string,
}

export default ConfirmModalV2
